













import { Component, Vue, Prop } from "vue-property-decorator";
import { ProductItem } from "../../common/interfaces";
import Store from "@/store/store";
import axios from "axios";
import PartItem from "./PartItem.vue";
import DetailHeader from "../DetailHeader.vue";

@Component({
  components: {
    DetailHeader,
    PartItem,
  },
})
export default class PartsSearch extends Vue {
  protected searchTerm: string = "";
  protected partList: ProductItem[] = [];
  protected searchingParts: boolean = false;

  public async searchParts() {
    this.searchingParts = true;
    const response = await axios.get(
      `${
        Store.state.Environment.ODataBaseUrl
      }/ProductItems()?$select=OperatingCompanyCode,ProductItemId,Description,SellingPrice,SellDecimals` +
        `&$filter=ProductItemGroupings/any(a:a/CodeId eq 'VANPARTS') and (contains(Description, '${
          this.searchTerm
        }') or contains(ProductItemId, '${this.searchTerm}'))`,
      {
        headers: {
          Authorization: "Bearer " + Store.state.User.AccessToken,
        },
      }
    );

    if (response.status === 200 && response.data) {
      this.partList = [];
      this.partList = response.data.value;
    }
    this.searchingParts = false;
  }
}
